import { render, staticRenderFns } from "./NominacionRegaliasIndex.vue?vue&type=template&id=0aee6fc8"
import script from "./NominacionRegaliasIndex.vue?vue&type=script&lang=js"
export * from "./NominacionRegaliasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports